import { AnimationBaseController, Inject } from "../../../modules/@denishussar/html5-game-engine";
import { IAnimationControllerConfiguration } from "../../../modules/@denishussar/html5-game-engine";
import { AnimationContents } from "../AnimationContents";
import { GameModel } from "../../Models/GameModel";


export class PopupBackgroundController extends AnimationBaseController {
    $model: GameModel;

    public constructor(@Inject private _options) {
        super("PopupBackgroundController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {

        return {
            animationContent: AnimationContents.MAIN_SCREEN_JSON,
            libraryName: "popup_background",
            onTap: e => {

            },
            modelWatch: {
                "showPopupShading": async (showPopupShading: boolean) => {
                    this.visible = showPopupShading;
                }
            },
        };
    }

    protected onInitialize(): void {
        this.visible = this.$model.showPopupShading;
    }

    protected onResize(width: number, height: number, scale: number): void {
        let sizeW = width / scale;
        let sizeH = height / scale;
        this.display.scale.set(sizeW / 50, sizeH / 50);
    }
}